import React from 'react'

import { useWindowSize } from '@smarty-nx/code-utils'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'
import { Link } from 'react-router-dom'

import content from './addon-helper-banner.content'
import classes from './addon-helper-banner.module.scss'
import { breakpoints, Button, Icon, Typography } from '../../../index'

const HelperCta = ({ url }: { url: string }) => (
  <Button
    as={(props) => <Link {...props} to={url} />}
    data-item-name="get-started"
    data-item-category={TRACKING_CATEGORIES.NAVIGATION}
  >
    {content.buttonTxt}
  </Button>
)

export const AddonHelperBanner = ({
  getStartedUrl,
}: {
  getStartedUrl: string
}) => {
  const { width = 0 } = useWindowSize()

  return width >= breakpoints['desktop-small'] ? (
    <div className={classes.addonHelperWrapper}>
      <div className={classes.bannerWrapper}>
        <div className={classes.bannerPartsWrapper}>
          <div className={classes.bannerHeading}>{content.heading}</div>
          <div className={classes.bannerDescription}>{content.description}</div>
          <div className={classes.ctaWrapper}>
            <HelperCta url={getStartedUrl} />
          </div>
        </div>
        <Icon className={classes.icon} name="smiley-phone" />
      </div>
    </div>
  ) : (
    <>
      <Typography variant="Kollektif/Small" component="h3">
        {content.heading}
      </Typography>
      <div className={classes.mobileBannerWrapper}>
        <div className={classes.imageWrapper}>
          <Icon className={classes.icon} name="smiley-phone" />
        </div>
        <div className={classes.bannerContent}>
          <div className={classes.bannerHeader}>{content.mobileHeading}</div>
          <div className={classes.ctaWrapper}>
            <HelperCta url={getStartedUrl} />
          </div>
        </div>
      </div>
    </>
  )
}
